import type { App, Plugin } from 'vue';

const WEBSITE_ID = import.meta.env.VITE_APP_MOUSE_FLOW_WEBSITE_ID;

const _window = window as any;
_window._mfq = _window._mfq || [];

function appendScript() {
  const mf = document.createElement("script");
  mf.type = "text/javascript";
  mf.defer = true;
  mf.src = `//cdn.mouseflow.com/projects/${WEBSITE_ID}.js`;
  document.head.appendChild(mf);
}

const MouseFlowPlugin: Plugin = {
  install(app: App) {
    appendScript();
  },
};

export default MouseFlowPlugin;